import { ApiResourceFactory } from './api.resource.factory'
import { ILocationsService, LocationsService } from './services/api.locations.service'
import { IDevicesService, DevicesService } from './services/api.devices.service'
import { ILoginService, LoginService } from './services/api.login.service'
import { IDictionariesService, DictionariesService } from './services/api.dictionary.service'
import { IGroupsService, GroupsService } from './services/api.groups.service'
import { IDashboardService, DashboardService } from './services/api.dashboard.service'
import { IMeasurementsService, MeasurementsService } from './services/api.measurements.service'
import { IMetersService, MetersService } from './services/api.meters.service'
import { IUsersService, UsersService } from './services/api.users.service'
import { IHistoryService, HistoryService } from './services/api.history.service'
import { IIssuesService, IssuesService } from './services/api.issues.service'
import { ITasksService, TasksService } from './services/api.tasks.service'
import { IAlarmsService, AlarmsService } from './services/api.alarms.service'
import { IDistributorsService, DistributorsService } from './services/api.distributors.service'
import { IAppService, AppService } from './services/api.app.service'
import { IRoutesService, RoutesService } from './services/api.routes.service'
import { IPasswordService, PasswordService } from './services/api.password.service'
import { IReportsService, ReportsService } from './services/api.reports.service'
import { ISsrsReportsService, SsrsReportsService } from './services/api.ssrs_reports.service'
import { ISimcardsService, SimcardsService } from './services/api.simcards.service'
import { IContactsService, ContactsService } from './services/api.contacts.service'
import { IActionsService, ActionsService } from './services/api.actions.service'
import { ISecureAppService, SecureAppService } from './services/api.secureapp.service'
import { IDeviceConnectionsService, DeviceConnectionsService } from './services/api.deviceconnections.service'
import { IAlarmGroupsService, AlarmGroupsService } from './services/api.alarm-groups.service'
import { IScriptsService, ScriptsService } from './services/api.scripts.service'
import { IKPIService, KPIService } from './services/api.kpi.service';
import { IServicemansService, ServicemansService } from './services/api.servicemans.service'
import { IDepositoriesService, DepositoriesService } from './services/api.depositories.service'

export class Api {
    constructor(public location: ILocationsService,
        public login: ILoginService,
        public dictionary: IDictionariesService,
        public device: IDevicesService,
        public group: IGroupsService,
        public dashboard: IDashboardService,
        public measurement: IMeasurementsService,
        public meter: IMetersService,
        public history: IHistoryService,
        public issue: IIssuesService,
        public task: ITasksService,
        public users: IUsersService,
        public distributor: IDistributorsService,
        public app: IAppService,
        public password: IPasswordService,
        public route: IRoutesService,
        public alarm: IAlarmsService,
        public report: IReportsService,
        public ssrsreport: ISsrsReportsService,
        public contact: IContactsService,
        public simcard: ISimcardsService,
        public actions: IActionsService,
        public deviceconnections: IDeviceConnectionsService,
        public alarmGroups: IAlarmGroupsService,
        public secureapp: ISecureAppService,
        public scripts: IScriptsService,
        public servicemans: IServicemansService,
        public kpi: IKPIService,
        public depositories: IDepositoriesService) {
    }
}

export class ApiProvider {
    $get = ['$q', 'apiResource', function ($q: ng.IQService, apiResource: ApiResourceFactory) {
        return new Api(
            new LocationsService(apiResource),
            new LoginService(apiResource),
            new DictionariesService(apiResource),
            new DevicesService(apiResource),
            new GroupsService(apiResource),
            new DashboardService(apiResource),
            new MeasurementsService(apiResource),
            new MetersService(apiResource),
            new HistoryService(apiResource),
            new IssuesService(apiResource),
            new TasksService(apiResource),
            new UsersService(apiResource),
            new DistributorsService(apiResource),
            new AppService(apiResource),
            new PasswordService(apiResource),
            new RoutesService(apiResource),
            new AlarmsService(apiResource),
            new ReportsService(apiResource),
            new SsrsReportsService(apiResource),
            new ContactsService(apiResource),
            new SimcardsService(apiResource),
            new ActionsService(apiResource),
            new DeviceConnectionsService(apiResource),
            new AlarmGroupsService(apiResource),
            new SecureAppService(apiResource),
            new ScriptsService(apiResource),
            new ServicemansService(apiResource),
            new KPIService(apiResource),
            new DepositoriesService(apiResource));
    }];
}